var _g, _path, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Minus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.516,0.516) scale(0.994,0.994)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "#000000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.12,86c0,43.65603 -35.46397,79.12 -79.12,79.12c-43.65603,0 -79.12,-35.46397 -79.12,-79.12c0,-43.65603 35.46397,-79.12 79.12,-79.12c43.65603,0 79.12,35.46397 79.12,79.12zM13.76,86c0,39.93779 32.30221,72.24 72.24,72.24c39.93779,0 72.24,-32.30221 72.24,-72.24c0,-39.93779 -32.30221,-72.24 -72.24,-72.24c-39.93779,0 -72.24,32.30221 -72.24,72.24zM127.28,82.56v6.88h-82.56v-6.88z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none",
    stroke: "none",
    strokeLinejoin: "miter"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,6.88c-43.65603,0 -79.12,35.46397 -79.12,79.12c0,43.65603 35.46397,79.12 79.12,79.12c43.65603,0 79.12,-35.46397 79.12,-79.12c0,-43.65603 -35.46397,-79.12 -79.12,-79.12zM86,13.76c39.93779,0 72.24,32.30221 72.24,72.24c0,39.93779 -32.30221,72.24 -72.24,72.24c-39.93779,0 -72.24,-32.30221 -72.24,-72.24c0,-39.93779 32.30221,-72.24 72.24,-72.24zM44.72,82.56v6.88h82.56v-6.88z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "none",
    strokeLinejoin: "miter"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Minus);
export default __webpack_public_path__ + "static/media/icons8-minus.ce52bfaa0e3a18735ab453e77af0547f.svg";
export { ForwardRef as ReactComponent };